// extracted by mini-css-extract-plugin
export default {"infoContainer":"betKalkulatoriTutorial_infoContainer__KO76k"};